import clone from 'clone'
import { initialState } from '../index'
import { removeFormatNumber } from '@/utils/number'
import { UNDERWRITING_INIT_LOADING, UNDERWRITING_INIT_SUCCESS, UNDERWRITING_INIT_FAIL, POLICY_RESET, POLICY_NEW_MODE, POLICY_REVIEW_MODE, POLICY_RENEWAL_MODE, POLICY_ENDORSEMENT_MODE, POLICY_CANCELLATION_MODE, POLICYGENERAL_INIT_LOADING, POLICYGENERAL_INIT_SUCCESS, POLICYGENERAL_INIT_FAIL, POLICYGENERAL_SAVE_LOADING, POLICYGENERAL_SAVE_SUCCESS,
  POLICYGENERAL_SAVE_FAIL, POLICYGENERAL_LOAD_DATA, POLICY_LIFECYCLE, POLICYHEADER_INIT_LOADING, POLICYHEADER_INIT_SUCCESS, POLICYHEADER_INIT_FAIL, POLICY_HEADER_TAB, POLICY_GENERAL, POLICY_MAIN, POLICY_INSURED, POLICY_OTHER_DETALS, POLICYRISKGROUP_INIT_LOADING, POLICYRISKGROUP_INIT_SUCCESS, POLICYRISKGROUP_INIT_FAIL, POLICY_RISK_GROUP,
  POLICYRISKGROUP_SAVE_LOADING, POLICYRISKGROUP_SAVE_SUCCESS, POLICYRISKGROUP_SAVE_FAIL, POLICYRISKGROUP_LIST, POLINSDDET_SAVE_LOADING, POLINSDDET_SAVE_SUCCESS, POLINSDDET_SAVE_FAIL, POLINSDDET_LIST, POLICY_SELECTED_RISKGRPNO, POLICY_SELECTED_RISKNO, POLICY_SELECTED_ITEMNO, POLICY_COVERAGE, POLICY_SUMMARY_TAB, POLICY_REINSURANCE_TAB,
  POLICY_REINSURANCE_RI_HEADER, POLICYQUERY_INIT_LOADING, POLICYQUERY_INIT_SUCCESS, POLICYQUERY_INIT_FAIL, POLICY_LEAVE, POLICY_ADDITIONAL_SETTINGS, POLICY_TOTALS, DELETEPOLICY_INIT_LOADING, DELETEPOLICY_INIT_FAIL, DELETEPOLICY_INIT_SUCCESS, POLICY_DOCUMENT_PRINT_SECTION, POLICY_SELECTED_PLANNO, POLICY_COVERAGE_DISCLDG_PD_GAP_CEDSI_AND_OUR_SHARE_SI,
  POLICYGENERAL_UPDATE_RIOUTMASTER_TRANDATE_LOADING, POLICYGENERAL_UPDATE_RIOUTMASTER_TRANDATE_SUCCESS, POLICYGENERAL_UPDATE_RIOUTMASTER_TRANDATE_FAIL } from '@/store/types'

export const init = {
  [UNDERWRITING_INIT_LOADING](state) {
    state.init = 0
    state.initErr = []
    state.menu = {}
  },
  [UNDERWRITING_INIT_SUCCESS](state, data) {
    state.init = 1
    state.initErr = []
    state.menu = data.menu
  },
  [UNDERWRITING_INIT_FAIL](state, error) {
    state.init = 2
    state.initErr = error
    state.menu = {}
  },
  [POLICY_RESET](state) {
    state.policy = clone(initialState.policy)
  },
  [POLICY_NEW_MODE](state) {
    state.policyMode = 'New'
  },
  [POLICY_REVIEW_MODE](state) {
    state.policyMode = 'Review'
  },
  [POLICY_RENEWAL_MODE](state) {
    state.policyMode = 'Renewal'
  },
  [POLICY_ENDORSEMENT_MODE](state) {
    state.policyMode = 'Endorsement'
  },
  [POLICY_CANCELLATION_MODE](state) {
    state.policyMode = 'Cancellation'
  },
  [POLICYGENERAL_INIT_LOADING](state) {
    state.policyGeneralSettings.init = 0
    state.policyGeneralSettings.initErr = []
    state.policyGeneralSettings.menu = {}
  },
  [POLICYGENERAL_INIT_SUCCESS](state, data) {
    state.policyGeneralSettings.init = 1
    state.policyGeneralSettings.initErr = []
    state.policyGeneralSettings.menu = data.menu
  },
  [POLICYGENERAL_INIT_FAIL](state, error) {
    state.policyGeneralSettings.init = 2
    state.policyGeneralSettings.initErr = error
    state.policyGeneralSettings.menu = {}
  },
  [POLICYGENERAL_SAVE_LOADING](state) {
    state.policy.init = 0
    state.policy.saving = true
    state.policy.saveError.fieldMessages = []
    state.policy.saveError.messages = []
  },
  [POLICYGENERAL_SAVE_SUCCESS](state) {
    state.policy.init = 1
    state.policy.saving = false
    state.policy.saveError.fieldMessages = []
    state.policy.saveError.messages = []
  },
  [POLICYGENERAL_SAVE_FAIL](state, errMsgs) {
    state.policy.init = 2
    state.policy.saving = false
    state.policy.saveError.fieldMessages = errMsgs.fieldMessages
    state.policy.saveError.messages = errMsgs.messages
  },
  [POLICYGENERAL_LOAD_DATA](state, fullData) {
    const { data } = fullData
    // policyInfo
    state.policy.policyInfo.polNo = data.polNo
    state.policy.policyInfo.renCnt = data.renCnt
    state.policy.policyInfo.endtCnt = data.endtCnt
    state.policy.policyInfo.branchDesc = data.branchDesc
    state.policy.policyInfo.polTypeDesc = data.polTypeDesc
    state.policy.policyInfo.fundDesc = data.fund
    state.policy.policyInfo.fromDate = data.comDate
    state.policy.policyInfo.endDate = data.expDate
    state.policy.policyInfo.uwYear = data.uwYr
    state.policy.policyInfo.insured = data.insdName1
    // OS-442: Added 14-Sep-2020
    state.policy.policyInfo.polStatDesc = data.polStatDesc
    state.policy.policyInfo.name = data.name
    state.policy.policyInfo.ctyDesc = data.ctyDesc
    state.policy.policyInfo.fundDescription = data.fundDesc
    state.policy.policyInfo.deptDesc = data.deptDesc
    state.policy.policyInfo.busSrcDesc = data.busSrcDesc
    state.policy.policyInfo.paytMethDesc = data.paytMethDesc
    state.policy.policyInfo.finInstName = data.finInstName
    state.policy.policyInfo.armName = data.armName
    state.policy.policyInfo.createdName = data.createdName
    state.policy.policyInfo.modifiedName = data.modifiedName
    state.policy.policyInfo.cedAntName = data.cedAntName
    state.policy.policyInfo.acctNoSfxDesc = data.acctNoSfxDesc
    state.policy.policyInfo.schemeDesc = data.schemeDesc
    state.policy.polMaster.polNo = data.polNo
    state.policy.polMaster.renCnt = data.renCnt
    state.policy.polMaster.endtCnt = data.endtCnt
    state.policy.polMaster.clientType = data.clientType
    state.policy.polMaster.tranDate = data.tranDate
    state.policy.polMaster.acceptDate = data.acceptDate
    state.policy.polMaster.acceptTime = data.acceptTime
    state.policy.polMaster.acct1DocNo = data.acct1DocNo
    state.policy.polMaster.acct1TranType1 = data.acct1TranType1
    state.policy.polMaster.acct2DocNo = data.acct2DocNo
    state.policy.polMaster.acct2TranType1 = data.acct2TranType1
    state.policy.polMaster.acct3DocNo = data.acct3DocNo
    state.policy.polMaster.acct3TranType1 = data.acct3TranType1
    state.policy.polMaster.acctNo1 = data.acctNo1
    state.policy.polMaster.acctNo2 = data.acctNo2
    state.policy.polMaster.acctNo3 = data.acctNo3
    state.policy.polMaster.agent = data.agent
    state.policy.polMaster.acctYr = data.acctYr
    state.policy.polMaster.acctMth = data.acctMth
    state.policy.polMaster.appCoIns = data.appCoIns
    state.policy.polMaster.billCoIns = data.billCoIns
    state.policy.polMaster.coInsPct = data.coInsPct
    state.policy.polMaster.appRiskTax = data.appRiskTax
    state.policy.polMaster.appShortTerm = data.appShortTerm
    state.policy.polMaster.batchRel = data.batchRel
    state.policy.polMaster.billCurr = data.billCurr
    state.policy.polMaster.billCurrRate = data.billCurrRate
    state.policy.polMaster.branch = data.branch
    state.policy.polMaster.busSrc = data.busSrc
    state.policy.polMaster.cedAnt = data.cedAnt
    state.policy.polMaster.acctNoSfx = data.acctNoSfx
    state.policy.polMaster.cedPolNo = data.cedPolNo
    state.policy.polMaster.cedCesNo = data.cedCesNo
    state.policy.polMaster.cedSI = data.cedSI
    state.policy.polMaster.ourSharePct = data.ourSharePct
    state.policy.polMaster.ourShareSi = data.ourShareSi
    state.policy.polMaster.cnType = data.cnType
    state.policy.polMaster.cnNo = data.cnNo
    state.policy.polMaster.cnDate = data.cnDate
    state.policy.polMaster.comDate = data.comDate
    state.policy.polMaster.comm1 = data.comm1
    state.policy.polMaster.comm2 = data.comm2
    state.policy.polMaster.comm3 = data.comm3
    state.policy.polMaster.cty = data.cty
    state.policy.polMaster.dept = data.dept
    state.policy.polMaster.disc = data.disc
    state.policy.polMaster.dri = data.dri
    state.policy.polMaster.endtDate = data.endtDate
    state.policy.polMaster.endtSeqNo = data.endtSeqNo
    state.policy.polMaster.entDate = data.entDate
    state.policy.polMaster.entUsrId = data.entUsrId
    state.policy.polMaster.expDate = data.expDate
    state.policy.polMaster.finInst = data.finInst
    state.policy.polMaster.firstIssDate = data.firstIssDate
    state.policy.polMaster.fund = data.fund
    state.policy.polMaster.genPolNo = data.genPolNo
    state.policy.polMaster.gstStatPrem = data.gstStatPrem
    state.policy.polMaster.gstStatComm1 = data.gstStatComm1
    state.policy.polMaster.gstStatComm2 = data.gstStatComm2
    state.policy.polMaster.gstStatComm3 = data.gstStatComm3
    state.policy.polMaster.gstRatePrem = data.gstRatePrem
    state.policy.polMaster.gstRateComm1 = data.gstRateComm1
    state.policy.polMaster.gstRateComm2 = data.gstRateComm2
    state.policy.polMaster.gstRateComm3 = data.gstRateComm3
    state.policy.polMaster.gstAEPrem = data.gstAEPrem
    state.policy.polMaster.gstAEComm1 = data.gstAEComm1
    state.policy.polMaster.gstAEComm2 = data.gstAEComm2
    state.policy.polMaster.gstAEComm3 = data.gstAEComm3
    state.policy.polMaster.gstPrem = data.gstPrem
    state.policy.polMaster.gstComm1 = data.gstComm1
    state.policy.polMaster.gstComm2 = data.gstComm2
    state.policy.polMaster.gstComm3 = data.gstComm3
    state.policy.polMaster.gstStatRateAEPrem = data.gstStatRateAEPrem
    state.policy.polMaster.gstStatRateAEComm1 = data.gstStatRateAEComm1
    state.policy.polMaster.gstStatRateAEComm2 = data.gstStatRateAEComm2
    state.policy.polMaster.gstStatRateAEComm3 = data.gstStatRateAEComm3
    state.policy.polMaster.issDate = data.issDate
    state.policy.polMaster.noCIPrt = data.noCIPrt
    state.policy.polMaster.noDrCrPrt = data.noDrCrPrt
    state.policy.polMaster.noTaxInvPrt = data.noTaxInvPrt
    state.policy.polMaster.noRiApplnPrt = data.noRiApplnPrt
    state.policy.polMaster.noSchedPrt = data.noSchedPrt
    state.policy.polMaster.occupation = data.occupation
    state.policy.polMaster.moCmpNo = data.moCmpNo
    state.policy.polMaster.paytMeth = data.paytMeth
    state.policy.polMaster.polEndtTxt = data.polEndtTxt
    state.policy.polMaster.polFee = data.polFee
    state.policy.polMaster.polLwrTxt = data.polLwrTxt
    state.policy.polMaster.polMemo = data.polMemo
    state.policy.polMaster.polPd = data.polPd
    state.policy.polMaster.polGap = data.polGap
    state.policy.polMaster.polRenTxt = data.polRenTxt
    state.policy.polMaster.polStamp = data.polStamp
    state.policy.polMaster.polStat = data.polStat
    state.policy.polMaster.polTax = data.polTax
    state.policy.polMaster.polType = data.polType
    state.policy.polMaster.polUppTxt = data.polUppTxt
    state.policy.polMaster.prevInsr = data.prevInsr
    state.policy.polMaster.progId = data.progId
    state.policy.polMaster.prtCILn = data.prtCILn
    state.policy.polMaster.prtDrCrLn = data.prtDrCrLn
    state.policy.polMaster.prtRiApplnLn = data.prtRiApplnLn
    state.policy.polMaster.prtSchedLn = data.prtSchedLn
    state.policy.polMaster.rcptNo = data.rcptNo
    state.policy.polMaster.recip = data.recip
    state.policy.polMaster.redBal1 = data.redBal1
    state.policy.polMaster.redBal2 = data.redBal2
    state.policy.polMaster.redBal3 = data.redBal3
    state.policy.polMaster.relDate = data.relDate
    state.policy.polMaster.relUsrId = data.relUsrId
    state.policy.polMaster.renPolNo = data.renPolNo
    state.policy.polMaster.riskFee = data.riskFee
    state.policy.polMaster.riskStamp = data.riskStamp
    state.policy.polMaster.riskTax = data.riskTax
    state.policy.polMaster.prevPolNo = data.prevPolNo
    state.policy.polMaster.prevPolExpDate = data.prevPolExpDate
    state.policy.polMaster.renSeqNo = data.renSeqNo
    state.policy.polMaster.retroDate = data.retroDate
    state.policy.polMaster.riFac = data.riFac
    state.policy.polMaster.schedForm = data.schedForm
    state.policy.polMaster.schedPremHead = data.schedPremHead
    state.policy.polMaster.scheme = data.scheme
    state.policy.polMaster.promotion = data.promotion
    state.policy.polMaster.securGrp = data.securGrp
    state.policy.polMaster.termDate = data.termDate
    state.policy.polMaster.totNoInstal = data.totNoInstal
    state.policy.polMaster.tranRel = data.tranRel
    state.policy.polMaster.tranType = data.tranType
    state.policy.polMaster.uwYr = data.uwYr
    state.policy.polMaster.endtType = data.endtType
    state.policy.polMaster.dateRenPrt = data.dateRenPrt
    state.policy.polMaster.discLdg1 = data.discLdg1
    state.policy.polMaster.discLdg2 = data.discLdg2
    state.policy.polMaster.discLdg3 = data.discLdg3
    state.policy.polMaster.endtForm = data.endtForm
    state.policy.polMaster.prtDiscLdg1 = data.prtDiscLdg1
    state.policy.polMaster.prtDiscLdg2 = data.prtDiscLdg2
    state.policy.polMaster.prtDiscLdg3 = data.prtDiscLdg3
    state.policy.polMaster.redBalDiscLdg2 = data.redBalDiscLdg2
    state.policy.polMaster.redBalDiscLdg3 = data.redBalDiscLdg3
    state.policy.polMaster.cpId = data.cpId
    state.policy.polMaster.cpBrn = data.cpBrn
    state.policy.polMaster.schedPrt = data.schedPrt
    state.policy.polMaster.drCrPrt = data.drCrPrt
    state.policy.polMaster.riLvl = data.riLvl
    state.policy.polMaster.discCommLvl = data.discCommLvl
    state.policy.polMaster.insdRefNo = data.insdRefNo
    state.policy.polMaster.titleName = data.titleName
    state.policy.polMaster.firstName = data.firstName
    state.policy.polMaster.insdName1 = data.insdName1
    state.policy.polMaster.insdName2 = data.insdName2
    state.policy.polMaster.insdName3 = data.insdName3
    state.policy.polMaster.insdAddr1 = data.insdAddr1
    state.policy.polMaster.insdAddr2 = data.insdAddr2
    state.policy.polMaster.insdAddr3 = data.insdAddr3
    state.policy.polMaster.insdAddr4 = data.insdAddr4
    state.policy.polMaster.postCode = data.postCode
    state.policy.polMaster.icNo = data.icNo
    state.policy.polMaster.telNo1 = data.telNo1
    state.policy.polMaster.telNo2 = data.telNo2
    state.policy.polMaster.mobile = data.mobile
    state.policy.polMaster.fax = data.fax
    state.policy.polMaster.email = data.email
    state.policy.polMaster.drCrNo = data.drCrNo
    state.policy.polMaster.modDate = data.modDate
    state.policy.polMaster.modUsrId = data.modUsrId
    state.policy.polMaster.grpPol = data.grpPol
    state.policy.polMaster.grpNamedPol = data.grpNamedPol
    state.policy.polMaster.empCont = data.empCont
    state.policy.polMaster.depdCont = data.depdCont
    state.policy.polMaster.stdBenRate = data.stdBenRate
    state.policy.polMaster.prtSchedInsd = data.prtSchedInsd
    state.policy.polMaster.prtSchedBen = data.prtSchedBen
    state.policy.polMaster.prtSchedPrem = data.prtSchedPrem
    state.policy.polMaster.execIC = data.execIC
    state.policy.polMaster.coRiPct = data.coRiPct
    state.policy.polMaster.maintPer = data.maintPer
    state.policy.polMaster.prtInsdDr = data.prtInsdDr
    state.policy.polMaster.industry = data.industry
    state.policy.polMaster.insBondNo = data.insBondNo
    state.policy.polMaster.totNoWrkmen = data.totNoWrkmen
    state.policy.polMaster.paiExpDate = data.paiExpDate
    state.policy.polMaster.medPolNo = data.medPolNo
    state.policy.polMaster.cedAcctNoSfx = data.cedAcctNoSfx
    state.policy.polMaster.dliabPer = data.dliabPer
    state.policy.polMaster.tpBill = data.tpBill
    state.policy.polMaster.phCltGrp = data.phCltGrp
    state.policy.polMaster.isPhGstReg = data.isPhGstReg
    state.policy.polMaster.gstRegNo = data.gstRegNo
    state.policy.polMaster.gstRegDate = data.gstRegDate
    state.policy.polMaster.polStampAE = data.polStampAE
    state.policy.polMaster.polFeeAE = data.polFeeAE
    state.policy.polMaster.polTaxAE = data.polTaxAE
    state.policy.polMaster.prtSubTaxInv = data.prtSubTaxInv
    state.policy.polMaster.premWar = data.premWar
    state.policy.polMaster.convEntUsrId = data.convEntUsrId
    state.policy.polMaster.convRelUsrId = data.convRelUsrId
    state.policy.polMaster.brkSlipNo = data.brkSlipNo
    state.policy.polMaster.brkTranRef = data.brkTranRef
    state.policy.polMaster.prtVarDesc = data.prtVarDesc
    state.policy.polMaster.acctNo2Sfx = data.acctNo2Sfx
    state.policy.polMaster.acctNo3Sfx = data.acctNo3Sfx
    state.policy.polMaster.agentAcctNoSfx = data.agentAcctNoSfx
    state.policy.polMaster.insdAddr5 = data.insdAddr5
    state.policy.polMaster.insdAddr6 = data.insdAddr6
    state.policy.polMaster.discLdg1Code = data.discLdg1Code
    state.policy.polMaster.discLdg2Code = data.discLdg2Code
    state.policy.polMaster.discLdg3Code = data.discLdg3Code
    state.policy.polMaster.insdName4 = data.insdName4
    state.policy.polMaster.moCmpUpld = data.moCmpUpld
    state.policy.polMaster.recHash = data.recHash
    state.policy.polMaster.prtTaxInvLn = data.prtTaxInvLn
    state.policy.polMaster.nxtBillMth = data.nxtBillMth
    state.policy.polMaster.billType = data.billType
    state.policy.polMaster.contractExpDate = data.contractExpDate
    state.policy.polMaster.cpCode = data.cpCode
    state.policy.polMaster.ccaDate = data.ccaDate
    state.policy.polMaster.ccdDate = data.ccdDate
    state.policy.polMaster.insdRefNoAE = data.insdRefNoAE
    state.policy.polMaster.insdStat = data.insdStat
    state.policy.polMaster.nationality = data.nationality
    state.policy.polMaster.icNoROC = data.icNoROC
    state.policy.polMaster.altName1 = data.altName1
    state.policy.polMaster.altName2 = data.altName2
    state.policy.polMaster.sameInsdAddr = data.sameInsdAddr
    state.policy.polMaster.altInsdAddr1 = data.altInsdAddr1
    state.policy.polMaster.altInsdAddr2 = data.altInsdAddr2
    state.policy.polMaster.altInsdAddr3 = data.altInsdAddr3
    state.policy.polMaster.altInsdAddr4 = data.altInsdAddr4
    state.policy.polMaster.altInsdAddr5 = data.altInsdAddr5
    state.policy.polMaster.altInsdAddr6 = data.altInsdAddr6
    state.policy.polMaster.altPostCode = data.altPostCode
    state.policy.polMaster.agtUsrId = data.agtUsrId
    state.policy.polMaster.stdRiskTxt = data.stdRiskTxt
    state.policy.polMaster.gender = data.gender
    state.policy.polMaster.dob = data.dob
    state.policy.polMaster.normOnRel = data.normOnRel
    state.policy.polMaster.endtCode = data.endtCode
    state.policy.polMaster.cancelCode = data.cancelCode
    state.policy.polMaster.entRilater = data.entRilater
    state.policy.polMaster.ipcStatus = data.ipcStatus
    state.policy.polMaster.ipcNo = data.ipcNo
    state.policy.polMaster.ipcSeqNo = data.ipcSeqNo
    state.policy.polMaster.ipcDate = data.ipcDate
    state.policy.polMaster.ourShareSi = data.ourShareSi
    state.policy.polMaster.ccDateEntDate = data.ccDateEntDate
    state.policy.polMaster.ccDateEntUsrId = data.ccDateEntUsrId
    state.policy.polMaster.ccDateRevDate = data.ccDateRevDate
    state.policy.polMaster.ccDateRevUsrId = data.ccDateRevUsrId
    state.policy.polMaster.polRenMsg = data.polRenMsg
    state.policy.polMaster.createdBy = data.createdBy
    state.policy.polMaster.createdDate = data.createdDate
    state.policy.polMaster.modifiedBy = data.modifiedBy
    state.policy.polMaster.modifiedDate = data.modifiedDate
    state.policy.polMaster.planNo = data.planNo
    state.policy.polMaster.planDesc = data.planDesc
    state.policy.polMaster.execICDesc = data.execICDesc
  },
  [POLICY_LIFECYCLE](state, data) {
    state.policy.policyLifeCycle = data
  },
  [POLICYHEADER_INIT_LOADING](state) {
    state.policyHeaderSettings.init = 0
    state.policyHeaderSettings.initErr = []
    state.policyHeaderSettings.menu = {}
  },
  [POLICYHEADER_INIT_SUCCESS](state, data) {
    state.policyHeaderSettings.init = 1
    state.policyHeaderSettings.initErr = []
    state.policyHeaderSettings.menu = data.menu
  },
  [POLICYHEADER_INIT_FAIL](state, error) {
    state.policyHeaderSettings.init = 2
    state.policyHeaderSettings.initErr = error
    state.policyHeaderSettings.menu = {}
  },
  [POLICY_HEADER_TAB](state, data) {
    state.policy.policyHeaderTab = data
  },
  [POLICY_GENERAL](state, data) {
    if (data) {
      state.policy.polMaster.dri = data.dRi
      state.policy.polMaster.appCoIns = data.appCoins
      state.policy.polMaster.branch = data.branch
      state.policy.polMaster.polType = data.polType
      state.policy.polMaster.polNo = data.polNo
      state.policy.polMaster.renCnt = data.renCnt
      state.policy.polMaster.endtCnt = data.endtCnt
      state.policy.polMaster.busSrc = data.busSrc
      state.policy.polMaster.billType = data.billType
      state.policy.polMaster.comDate = data.comDate
      state.policy.polMaster.expDate = data.expDate
      state.policy.polMaster.endtDate = data.endtDate
      state.policy.polMaster.uwYr = data.uwYr
      state.policy.polMaster.tranDate = data.tranDate
      state.policy.polMaster.firstIssDate = data.firstIssDate
      state.policy.polMaster.acceptDate = data.acceptDate
      state.policy.polMaster.acceptTime = data.acceptTime
      state.policy.polMaster.tranType = data.tranType
      state.policy.polMaster.endtCode = data.endtCode
      state.policy.polMaster.cancelCode = data.cancelCode
    }
  },
  [POLICY_MAIN](state, data) {
    if (data) {
      state.policy.polMaster.prevPolNo = data.prevPolNo
      state.policy.polMaster.moCmpUpld = data.moCmpUpld
      state.policy.polMaster.moCmpNo = data.moCmpNo
      state.policy.polMaster.cty = data.cty
      state.policy.polMaster.polStat = data.polStat
      state.policy.polMaster.acctNo1 = data.acctNo1
      state.policy.polMaster.acctNoSfx = data.acctNoSfx
      state.policy.polMaster.billCurr = data.billCurr
      state.policy.polMaster.billCurrRate = data.billCurrRate
      state.policy.polMaster.scheme = data.scheme
      state.policy.polMaster.promotion = data.promotion
      state.policy.polMaster.paytMeth = data.paytMeth
      state.policy.polMaster.stdRiskTxt = data.stdRiskTxt
      state.policy.polMaster.stdRiskTxt = data.stdRiskTxt
      state.policy.polMaster.finInst = data.finInst
      state.policy.polMaster.agent = data.agent
      // state.policy.polMaster.cpId = data.cpId
      state.policy.polMaster.cpCode = data.cpCode
      state.policy.polMaster.appShortTerm = data.appShortTerm
      state.policy.polMaster.appRiskTax = data.appRiskTax
      state.policy.polMaster.cedAnt = data.cedAnt
      state.policy.polMaster.cedAcctNoSfx = data.cedAcctNoSfx
      state.policy.polMaster.cedSI = removeFormatNumber(data.cedSI)
      state.policy.polMaster.ourSharePct = removeFormatNumber(data.ourSharePct)
      state.policy.polMaster.ourShareSi = removeFormatNumber(data.ourShareSi)
      state.policy.polMaster.cedPolNo = data.cedPolNo
      state.policy.polMaster.cedCesNo = data.cedCesNo
      state.policy.polMaster.recip = data.recip
      state.policy.polMaster.ccaDate = data.ccaDate
      state.policy.polMaster.ccdDate = data.ccdDate
      state.policy.polMaster.billCoIns = data.billCoIns
      state.policy.polMaster.coInsPct = data.coInsPct
      state.policy.polMaster.ccDateEntDate = data.ccDateEntDate
      state.policy.polMaster.ccDateEntUsrId = data.ccDateEntUsrId
      state.policy.polMaster.ccDateRevDate = data.ccDateRevDate
      state.policy.polMaster.ccDateRevUsrId = data.ccDateRevUsrId
      if (data.paPolCoverType !== undefined) {
        state.policy.polMaster.grpPol = data.paPolCoverType
        state.policy.polMaster.grpNamedPol = data.paGroupType
      } else if (data.medPolCoverType !== undefined) {
        state.policy.polMaster.grpPol = data.medPolCoverType
        state.policy.polMaster.grpNamedPol = data.medGroupType
      } else {
        state.policy.polMaster.grpPol = false
        state.policy.polMaster.grpNamedPol = false
      }
      state.policy.polMaster.stdBenRate = data.stdBenRate
      state.policy.polMaster.empCont = data.empCont
      state.policy.polMaster.depdCont = data.depdCont
      state.policy.polMaster.prtSchedInsd = data.prtSchedInsd
      state.policy.polMaster.prtSchedBen = data.prtSchedBen
      state.policy.polMaster.prtSchedPrem = data.prtSchedPrem

      // Policy Text
      state.policy.polMaster.polUppTxt = data.polUppTxt
      state.policy.polMaster.polLwrTxt = data.polLwrTxt
      state.policy.polMaster.polMemo = data.polMemo
      state.policy.polMaster.polEndtTxt = data.polEndtTxt
      state.policy.polMaster.polRenTxt = data.polRenTxt

      state.policy.polMaster.noDrCrPrt = data.noDrCrPrt
      state.policy.polMaster.noTaxInvPrt = data.noTaxInvPrt
    }
  },
  [POLICY_INSURED](state, data) {
    if (data) {
      state.policy.polMaster.insdRefNoAE = data.insdRefNoAE
      state.policy.polMaster.insdRefNo = data.insdRefNo
      state.policy.polMaster.clientType = data.clientType
      state.policy.polMaster.insdStat = data.insdStat
      state.policy.polMaster.titleName = data.titleName
      state.policy.polMaster.insdName1 = data.insdName1
      state.policy.polMaster.insdName2 = data.insdName2
      state.policy.polMaster.insdName3 = data.insdName3
      state.policy.polMaster.insdAddr1 = data.insdAddr1
      state.policy.polMaster.insdAddr2 = data.insdAddr2
      state.policy.polMaster.insdAddr3 = data.insdAddr3
      state.policy.polMaster.insdAddr4 = data.insdAddr4
      state.policy.polMaster.insdAddr5 = data.insdAddr5
      state.policy.polMaster.insdAddr6 = data.insdAddr6
      state.policy.polMaster.postCode = data.postCode
      state.policy.polMaster.telNo1 = data.telNo1
      state.policy.polMaster.telNo2 = data.telNo2
      state.policy.polMaster.mobile = data.mobile
      state.policy.polMaster.fax = data.fax
      state.policy.polMaster.email = data.email
      state.policy.polMaster.nationality = data.nationality
      state.policy.polMaster.occupation = data.occupation
      if (state.policy.polMaster.insdStat === 'I') {
        state.policy.polMaster.icNo = data.icNo
        // AR: Commented 29-Sep-2020
        // state.policy.polMaster.icNoROC = data.icNo
        // JJ: Set to clear 10-Oct-2020
        state.policy.polMaster.icNoROC = ''
      } else {
        state.policy.polMaster.icNoROC = data.roc
        // JJ: Set to clear 10-Oct-2020
        state.policy.polMaster.icNo = ''
      }
      // state.policy.polMaster.icNo = data.icNo
      state.policy.polMaster.dob = data.dob
      state.policy.polMaster.gender = data.gender
      // roc
      state.policy.polMaster.gstRegDate = data.gstRegDate
      state.policy.polMaster.gstRegNo = data.gstRegNo
      state.policy.polMaster.altName1 = data.altName1
      state.policy.polMaster.altName2 = data.altName2
      state.policy.polMaster.sameInsdAddr = data.sameInsdAddr
      state.policy.polMaster.altInsdAddr1 = data.altInsdAddr1
      state.policy.polMaster.altInsdAddr2 = data.altInsdAddr2
      state.policy.polMaster.altInsdAddr3 = data.altInsdAddr3
      state.policy.polMaster.altInsdAddr4 = data.altInsdAddr4
      state.policy.polMaster.altInsdAddr5 = data.altInsdAddr5
      state.policy.polMaster.altInsdAddr6 = data.altInsdAddr6
      state.policy.polMaster.altPostCode = data.altPostCode
    }
  },
  [POLICY_OTHER_DETALS](state, data) {
    if (data) {
      state.policy.polMaster.issDate = data.issDate
      state.policy.polMaster.retroDate = data.retroDate
      state.policy.polMaster.dept = data.dept
      state.policy.polMaster.maintPer = data.maintPer
      state.policy.polMaster.dliabPer = data.dliabPer
      state.policy.polMaster.execIC = data.execIC
      state.policy.polMaster.agtUsrId = data.agtUsrId
    }
  },
  [POLICYRISKGROUP_INIT_LOADING](state) {
    state.policyRiskGroupSettings.init = 0
    state.policyRiskGroupSettings.initErr = []
    state.policyRiskGroupSettings.menu = {}
  },
  [POLICYRISKGROUP_INIT_SUCCESS](state, data) {
    state.policyRiskGroupSettings.init = 1
    state.policyRiskGroupSettings.initErr = []
    state.policyRiskGroupSettings.menu = data.menu
  },
  [POLICYRISKGROUP_INIT_FAIL](state, error) {
    state.policyRiskGroupSettings.init = 2
    state.policyRiskGroupSettings.initErr = error
    state.policyRiskGroupSettings.menu = {}
  },
  [POLICY_RISK_GROUP](state, data) {
    if (data) {
      state.policy.polRiskGrp.polNo = data.polNo
      state.policy.polRiskGrp.renCnt = data.renCnt
      state.policy.polRiskGrp.endtCnt = data.endtCnt
      state.policy.polRiskGrp.riskGrpNo = data.riskGrpNo
      state.policy.polRiskGrp.delRiskGrp = data.delRiskGrp
      state.policy.polRiskGrp.noAdult = data.noAdult
      state.policy.polRiskGrp.noChild = data.noChild
      state.policy.polRiskGrp.planNo = data.planNo
      state.policy.polRiskGrp.grpUppTxt = data.grpUppTxt
      state.policy.polRiskGrp.grpLwrTxt = data.grpLwrTxt
      state.policy.polRiskGrp.grpMemo = data.grpMemo
      state.policy.polRiskGrp.grpStdTxt = data.grpStdTxt
      state.policy.polRiskGrp.insdRefNo = data.insdRefNo
      state.policy.polRiskGrp.titleName = data.titleName
      state.policy.polRiskGrp.firstName = data.firstName
      state.policy.polRiskGrp.insdName1 = data.insdName1
      state.policy.polRiskGrp.insdName2 = data.insdName2
      state.policy.polRiskGrp.insdName3 = data.insdName3
      state.policy.polRiskGrp.insdAddr1 = data.insdAddr1
      state.policy.polRiskGrp.insdAddr2 = data.insdAddr2
      state.policy.polRiskGrp.insdAddr3 = data.insdAddr3
      state.policy.polRiskGrp.insdAddr4 = data.insdAddr4
      state.policy.polRiskGrp.insdAddr5 = data.insdAddr5
      state.policy.polRiskGrp.insdAddr6 = data.insdAddr6
      state.policy.polRiskGrp.postCode = data.postCode
      state.policy.polRiskGrp.noLive = data.noLive
      state.policy.polRiskGrp.insdName4 = data.insdName4
      state.policy.polRiskGrp.insdPremises = data.insdPremises
      state.policy.polMaster.planNo = data.planNo
    }
  },
  [POLICYRISKGROUP_SAVE_LOADING](state) {
    state.policy.polRiskGrp.init = 0
    state.policy.polRiskGrp.saving = true
    state.policy.polRiskGrp.saveError.fieldMessages = []
    state.policy.polRiskGrp.saveError.messages = []
  },
  [POLICYRISKGROUP_SAVE_SUCCESS](state) {
    state.policy.polRiskGrp.init = 1
    state.policy.polRiskGrp.saving = false
    state.policy.polRiskGrp.saveError.fieldMessages = []
    state.policy.polRiskGrp.saveError.messages = []
  },
  [POLICYRISKGROUP_SAVE_FAIL](state, errMsgs) {
    state.policy.polRiskGrp.init = 2
    state.policy.polRiskGrp.saving = false
    state.policy.polRiskGrp.saveError.fieldMessages = errMsgs.fieldMessages
    state.policy.polRiskGrp.saveError.messages = errMsgs.messages
  },
  [POLICYRISKGROUP_LIST](state, fullData) {
    const { data } = fullData
    state.policy.polMaster.polRiskGrps = data.data
    state.policy.polMaster.planDesc = data.data[0].planDesc
  },
  [POLINSDDET_SAVE_LOADING](state) {
    state.policy.polInsdDet.init = 0
    state.policy.polInsdDet.saving = true
    state.policy.polInsdDet.saveError.fieldMessages = []
    state.policy.polInsdDet.saveError.messages = []
  },
  [POLINSDDET_SAVE_SUCCESS](state) {
    state.policy.polInsdDet.init = 1
    state.policy.polInsdDet.saving = false
    state.policy.polInsdDet.saveError.fieldMessages = []
    state.policy.polInsdDet.saveError.messages = []
  },
  [POLINSDDET_SAVE_FAIL](state, errMsgs) {
    state.policy.polInsdDet.init = 2
    state.policy.polInsdDet.saving = false
    state.policy.polInsdDet.saveError.fieldMessages = errMsgs.fieldMessages
    state.policy.polInsdDet.saveError.messages = errMsgs.messages
  },
  [POLINSDDET_LIST](state, fullData) {
    const { data } = fullData
    state.policy.polMaster.polInsdDets = data.data
  },
  [POLICY_SELECTED_RISKGRPNO](state, data) {
    state.policy.selectedRiskGrpNo = data
  },
  [POLICY_SELECTED_RISKNO](state, data) {
    state.policy.selectedRiskNo = data
  },
  [POLICY_SELECTED_ITEMNO](state, data) {
    state.policy.selectedItemNo = data
  },
  [POLICY_SELECTED_PLANNO](state, data) {
    state.policy.selectedPlanNo = data
  },
  [POLICY_COVERAGE](state, data) {
    if (data) {
      state.policy.polMaster.discLdg1Code = data.discLdg1Code
      state.policy.polMaster.discLdg2Code = data.discLdg2Code
      state.policy.polMaster.discLdg3Code = data.discLdg3Code
      state.policy.polMaster.redBalDiscLdg2 = data.redBalDiscLdg2
      state.policy.polMaster.redBalDiscLdg3 = data.redBalDiscLdg3
      state.policy.polMaster.prtDiscLdg1 = data.prtDiscLdg1
      state.policy.polMaster.prtDiscLdg2 = data.prtDiscLdg2
      state.policy.polMaster.prtDiscLdg3 = data.prtDiscLdg3
    }
  },
  [POLICY_SUMMARY_TAB](state, data) {
    state.policy.policySummaryTab = data
  },
  [POLICY_REINSURANCE_TAB](state, data) {
    state.policy.policyReinsuranceTab = data
  },
  [POLICY_REINSURANCE_RI_HEADER](state, data) {
    state.policy.policyRiData = data
  },
  [POLICYQUERY_INIT_LOADING](state) {
    state.policyQuerySettings.init = 0
    state.policyQuerySettings.initErr = []
    state.policyQuerySettings.menu = {}
  },
  [POLICYQUERY_INIT_SUCCESS](state, data) {
    state.policyQuerySettings.init = 1
    state.policyQuerySettings.initErr = []
    state.policyQuerySettings.menu = data.menu
  },
  [POLICYQUERY_INIT_FAIL](state, error) {
    state.policyQuerySettings.init = 2
    state.policyQuerySettings.initErr = error
    state.policyQuerySettings.menu = {}
  },
  [POLICY_LEAVE](state) {
    state.policy.promptWhenExit = false
  },
  [POLICY_ADDITIONAL_SETTINGS](state, data) {
    if (data) {
      state.policy.polMaster.drCrNo = data.drCrNo
      state.policy.polMaster.acct1DocNo = data.acct1DocNo
      state.policy.polMaster.prtInsdDr = data.prtInsdDr
      state.policy.polMaster.totNoInstal = data.totNoInstal
      state.policy.polMaster.rcptNo = data.rcptNo
      state.policy.polMaster.riFac = data.riFac
      state.policy.polMaster.entRilater = data.entRilater
    }
  },
  [POLICY_TOTALS](state, data) {
    if (data) {
      state.policy.polMaster.polStampAE = data.polStampAE
      state.policy.polMaster.polFeeAE = data.polFeeAE
      state.policy.polMaster.polTaxAE = data.polTaxAE
      state.policy.polMaster.polStamp = removeFormatNumber(data.polStamp)
      state.policy.polMaster.polFee = removeFormatNumber(data.polFee)
      state.policy.polMaster.polTax = removeFormatNumber(data.polTax)
      state.policy.polMaster.gstStatPrem = data.gstStatPrem
      state.policy.polMaster.gstStatComm1 = data.gstStatComm1
      state.policy.polMaster.gstStatComm2 = data.gstStatComm2
      state.policy.polMaster.gstStatComm3 = data.gstStatComm3
      state.policy.polMaster.gstRatePrem = removeFormatNumber(data.gstRatePrem)
      state.policy.polMaster.gstRateComm1 = removeFormatNumber(data.gstRateComm1)
      state.policy.polMaster.gstRateComm2 = removeFormatNumber(data.gstRateComm2)
      state.policy.polMaster.gstRateComm3 = removeFormatNumber(data.gstRateComm3)
      state.policy.polMaster.gstAEPrem = data.gstAEPrem
      state.policy.polMaster.gstAEComm1 = data.gstAEComm1
      state.policy.polMaster.gstAEComm2 = data.gstAEComm2
      state.policy.polMaster.gstAEComm3 = data.gstAEComm3
      state.policy.polMaster.gstPrem = removeFormatNumber(data.gstPrem)
      state.policy.polMaster.gstComm1 = removeFormatNumber(data.gstComm1)
      state.policy.polMaster.gstComm2 = removeFormatNumber(data.gstComm2)
      state.policy.polMaster.gstComm3 = removeFormatNumber(data.gstComm3)
      state.policy.polMaster.gstStatRateAEPrem = data.gstStatRateAEPrem
      state.policy.polMaster.gstStatRateAEComm1 = data.gstStatRateAEComm1
      state.policy.polMaster.gstStatRateAEComm2 = data.gstStatRateAEComm2
      state.policy.polMaster.gstStatRateAEComm3 = data.gstStatRateAEComm3
    }
  },
  [DELETEPOLICY_INIT_LOADING](state) {
    state.deletePolicySettings.init = 0
    state.deletePolicySettings.initErr = []
    state.deletePolicySettings.menu = {}
  },
  [DELETEPOLICY_INIT_SUCCESS](state, data) {
    state.deletePolicySettings.init = 1
    state.deletePolicySettings.initErr = []
    state.deletePolicySettings.menu = data.menu
  },
  [DELETEPOLICY_INIT_FAIL](state, error) {
    state.deletePolicySettings.init = 2
    state.deletePolicySettings.initErr = error
    state.deletePolicySettings.menu = {}
  },
  [POLICY_DOCUMENT_PRINT_SECTION](state, data) {
    if (data) {
      state.policy.polMaster.schedPremHead = data.schedPremHead
      state.policy.polMaster.endtForm = data.endtForm
      state.policy.polMaster.prtSchedLn = data.prtSchedLn
      state.policy.polMaster.noSchedPrt = data.noSchedPrt
      state.policy.polMaster.prtDrCrLn = data.prtDrCrLn
      state.policy.polMaster.noDrCrPrt = data.noDrCrPrt
      state.policy.polMaster.prtCILn = data.prtCILn
      state.policy.polMaster.noCIPrt = data.noCIPrt
      state.policy.polMaster.prtRiApplnLn = data.prtRiApplnLn
      state.policy.polMaster.noRiApplnPrt = data.noRiApplnPrt
      state.policy.polMaster.prtTaxInvLn = data.prtTaxInvLn
      state.policy.polMaster.noTaxInvPrt = data.noTaxInvPrt
      state.policy.polMaster.schedForm = data.schedForm
    }
  },
  [POLICY_COVERAGE_DISCLDG_PD_GAP_CEDSI_AND_OUR_SHARE_SI](state, data) {
    if (data) {
      state.policy.polMaster.discLdg1 = data.discLdg1
      state.policy.polMaster.discLdg2 = data.discLdg2
      state.policy.polMaster.discLdg3 = data.discLdg3
      state.policy.polMaster.discLdg3 = data.discLdg3
      state.policy.polMaster.polPd = data.polPd
      state.policy.polMaster.polGap = data.polGap
      state.policy.polMaster.cedSi = data.cedSi
      state.policy.polMaster.ourShareSi = data.ourShareSi
    }
  },
  [POLICYGENERAL_UPDATE_RIOUTMASTER_TRANDATE_LOADING](state) {
    state.policy.init = 0
    state.policy.saving = true
    state.policy.saveError.fieldMessages = []
    state.policy.saveError.messages = []
  },
  [POLICYGENERAL_UPDATE_RIOUTMASTER_TRANDATE_SUCCESS](state) {
    state.policy.init = 1
    state.policy.saving = false
    state.policy.saveError.fieldMessages = []
    state.policy.saveError.messages = []
  },
  [POLICYGENERAL_UPDATE_RIOUTMASTER_TRANDATE_FAIL](state, errMsgs) {
    state.policy.init = 2
    state.policy.saving = false
    state.policy.saveError.fieldMessages = errMsgs.fieldMessages
    state.policy.saveError.messages = errMsgs.messages
  }
}
